import { EpimsBaseEntityDto } from './epim-base.dto';
export class StakeholderRepDto extends EpimsBaseEntityDto {
  
  StakeholderRepName: string;
  StakeholderRepPhone: string;
  StakeholderRepEmail: string;
  StakeholderRepDesignation: string;
  PipelineLicenseStakeholderId: string;
  StakeholderRepStatus: string;
  SubscriptionUserId: string;  
  Version: number;
}
